module.exports = __webpack_public_path__ + "static/images/d1694efb6ac72001785f44fc1b28c15f.svg";